import React from "react";
// Import useNavigate from react-router-dom for navigation
import { useNavigate } from "react-router-dom";
import "./ProjectSection.css";

// Import project images (you'll need to add these to your project)
import RisenStarGoods from "../assets/images/projectimg/mainRisenStar.jpg";
import WebDevPortfolio from "../assets/images/projectimg/WEB DEV PORTFOLIO.jpg";
import Brochure from "../assets/images/projectimg/brochure.jpg";
// ... (other imports)

const ProjectSection = () => {
  // 1. Initialize the useNavigate hook
  const navigate = useNavigate();

  const projects = [
    // ... (your existing projects array)
    {
      id: 1,
      title: "Wholesale Store",
      description: "Static Website for a WholeSale Online Store",
      image: RisenStarGoods,
      link: "https://www.risenstargoods.com",
    },
    {
      id: 2,
      title: "Portfolio for Web Developer",
      description: "Creative portfolio for A web develper team",
      image: WebDevPortfolio,
      link: "https://mtalhawebportfolio.netlify.app/",
    },
    {
      id: 3,
      title: "Brochure Designs",
      description: "Brochures that were designed for marketing",
      image: Brochure,
      link: "https://www.behance.net/gallery/232561759/Brochure-and-Poster-Design",
    },
  ];

  const handleProjectClick = (link) => {
    window.open(link, "_blank");
  };

  // 2. Create the handler for the View All button
  const handleViewAllClick = () => {
    // Navigate to the '/projects' route
    navigate("/projects");
  };

  return (
    <section id="projects" className="project-section ">
      <div className="container">
        <div className="home-project-header mb-5 ">
          <h3 className="home-project-title fw-bold mb-3">Recent Projects</h3>
          <p className="home-project-subtitle col-lg-6 mb-0">
            First powerful website to develop a data-accounting-manipulation
            forage
            <br />
            semi-base in the past 20 years ago.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project) => (
            <div
              className="home-project-card"
              key={project.id}
              onClick={() => handleProjectClick(project.link)}
            >
              <div className="home-project-image-container">
                <img
                  src={project.image}
                  alt={project.title}
                  className="home-project-image"
                />
                <div className="home-project-overlay">
                  <div className="home-project-content">
                    <h4 className="home-project-card-title">{project.title}</h4>
                    <p className="home-project-card-desc">
                      {project.description}
                    </p>
                    <span className="home-project-link">View Project →</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="viewall-btn mb-5">
          <button
            className="btn btn-outline-dark px-4 mt-4"
            // 3. Attach the new handler to the onClick event
            onClick={handleViewAllClick}
          >
            View All
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
